export const FETCH_REGION_ATTRIBUTES_REQUEST = "FETCH_REGION_ATTRIBUTES_REQUEST";
export const FETCH_REGION_ATTRIBUTES_SUCCESS = "FETCH_REGION_ATTRIBUTES_SUCCESS";
export const FETCH_REGION_ATTRIBUTES_ERROR = "FETCH_REGION_ATTRIBUTES_ERROR";
export const UPDATE_REGION_ATTRIBUTES = "UPDATE_REGION_ATTRIBUTES";
export const SET_REGION_MARKET_LIST = "SET_REGION_MARKET_LIST";
